/**
 * Where clicking a notification should take the user.
 * Ticket and To Do notifications jump straight to the item; everything else
 * opens the generic notification detail page.
 */
export const notificationTarget = (n) => {
  if (!n) return "/user/notifications";
  if (n.requestType === "Task") {
    return n.link || "/user/todo";
  }
  if (n.requestType === "Ticket") {
    return (
      n.link ||
      (n.requestId
        ? `/ticketing/tickets/${n.requestId}`
        : `/user/notifications/${n.id}`)
    );
  }
  return `/user/notifications/${n.id}`;
};
